export const LANGUAGES = {
    en: { name: 'English', dir: 'ltr' },
    hi: { name: 'हिंदी', dir: 'ltr' },
    ta: { name: 'தமிழ்', dir: 'ltr' },
    // Assam Languages
    as: { name: 'অসমীয়া', dir: 'ltr' },      // Assamese - Official language of Assam
    bn: { name: 'বাংলা', dir: 'ltr' },         // Bengali - Spoken in Barak Valley
    brx: { name: 'बड़ो', dir: 'ltr' },          // Bodo - Recognized tribal language
    kha: { name: 'কাৰ্বি', dir: 'ltr' }         // Karbi - Karbi tribal language
};

export const translations = {
    en: {
        welcome: 'Welcome to SUVIDHA',
        subtitle: 'Smart Urban Virtual Interactive Digital Helpdesk Assistant',
        selectService: 'Select a Service',
        electricity: 'Electricity',
        gas: 'Gas',
        water: 'Water',
        waste: 'Waste Management',
        login: 'Citizen Login',
        loginSubtitle: 'Secure authentication required',
        consumerId: 'Consumer ID / Mobile',
        password: 'Password / OTP',
        loginBtn: 'Login Securely',
        services: 'Services',
        payBill: 'Pay Bill',
        newConnection: 'New Connection',
        complaints: 'Register Complaint',
        trackStatus: 'Track Status',
        viewBill: 'View Bill',
        meterReading: 'Submit Meter Reading',
        logout: 'Logout',
        dashboard: 'Dashboard',
        accountDetails: 'Account Details',
        consumptionHistory: 'Consumption History',
        recentActivity: 'Recent Activity',
        notifications: 'Notifications',
        downloadReceipt: 'Download Receipt',
        makePayment: 'Make Payment',
        amount: 'Amount',
        payNow: 'Pay Now',
        submit: 'Submit',
        cancel: 'Cancel',
        success: 'Success!',
        processing: 'Processing...',
        back: 'Back to Dashboard',
        selectLanguage: 'Select Language',
        noNotifications: 'No new notifications',
        billAmount: 'Bill Amount',
        dueDate: 'Due Date',
        status: 'Status',
        paid: 'Paid',
        pending: 'Pending',
        overdue: 'Overdue',
        complaintType: 'Complaint Type',
        description: 'Description',
        uploadDoc: 'Upload Document',
        trackingId: 'Tracking ID',
        newConnectionType: 'Connection Type',
        address: 'Address',
        idProof: 'ID Proof',
        addressProof: 'Address Proof',
        powerOutage: 'Power Outage',
        billing: 'Billing Issue',
        meterFault: 'Meter Fault',
        gasLeak: 'Gas Leak',
        lowPressure: 'Low Pressure',
        waterSupply: 'Water Supply Issue',
        qualityIssue: 'Water Quality',
        missedCollection: 'Missed Collection',
        illegalDumping: 'Illegal Dumping',
        residential: 'Residential',
        commercial: 'Commercial',
        industrial: 'Industrial',
        adminDashboard: 'Admin Dashboard',
        totalTransactions: 'Total Transactions',
        activeComplaints: 'Active Complaints',
        todayCollection: 'Today\'s Collection',
        kioskUsage: 'Kiosk Usage',
        // Registration translations
        register: 'Register',
        registerSubtitle: 'Create your account using Aadhaar',
        aadhaarNumber: 'Aadhaar Number',
        verifyAadhaar: 'Verify Aadhaar',
        personalDetails: 'Personal Details',
        fullName: 'Full Name',
        email: 'Email Address',
        mobile: 'Mobile Number',
        alternateMobile: 'Alternate Mobile',
        dateOfBirth: 'Date of Birth',
        gender: 'Gender',
        residentialAddress: 'Residential Address',
        addressLine1: 'Address Line 1',
        addressLine2: 'Address Line 2',
        landmark: 'Landmark',
        city: 'City',
        district: 'District',
        state: 'State',
        pincode: 'Pincode',
        createPassword: 'Create Password',
        confirmPassword: 'Confirm Password',
        profilePhoto: 'Profile Photo',
        reviewSubmit: 'Review & Submit',
        completeRegistration: 'Complete Registration',
        registrationSuccess: 'Registration Successful!',
        alreadyRegistered: 'Already have an account?',
        newUser: 'New User?',
        // Receipt translations
        receipt: 'Receipt',
        transactionId: 'Transaction ID',
        paymentDate: 'Payment Date',
        paymentMethod: 'Payment Method',
        customerDetails: 'Customer Details',
        serviceDetails: 'Service Details',
        billingPeriod: 'Billing Period',
        consumption: 'Consumption',
        billId: 'Bill ID',
        sendToMobile: 'Send to Mobile',
        sendToEmail: 'Send to Email',
        printReceipt: 'Print Receipt',
        downloadPDF: 'Download PDF',
        receiptGenerated: 'Your receipt has been generated',
        sent: 'Sent!',
        serviceType: 'Service Type',
    },
    hi: {
        welcome: 'सुविधा में आपका स्वागत है',
        subtitle: 'स्मार्ट शहरी डिजिटल सहायक',
        selectService: 'सेवा चुनें',
        electricity: 'बिजली',
        gas: 'गैस',
        water: 'पानी',
        waste: 'कचरा प्रबंधन',
        login: 'नागरिक लॉगिन',
        loginSubtitle: 'सुरक्षित प्रमाणीकरण आवश्यक',
        consumerId: 'उपभोक्ता आईडी / मोबाइल',
        password: 'पासवर्ड / ओटीपी',
        loginBtn: 'सुरक्षित लॉगिन करें',
        services: 'सेवाएं',
        payBill: 'बिल भुगतान',
        newConnection: 'नया कनेक्शन',
        complaints: 'शिकायत दर्ज करें',
        trackStatus: 'स्थिति ट्रैक करें',
        viewBill: 'बिल देखें',
        meterReading: 'मीटर रीडिंग जमा करें',
        logout: 'लॉगआउट',
        dashboard: 'डैशबोर्ड',
        accountDetails: 'खाता विवरण',
        consumptionHistory: 'खपत इतिहास',
        recentActivity: 'हाल की गतिविधि',
        notifications: 'सूचनाएं',
        downloadReceipt: 'रसीद डाउनलोड करें',
        makePayment: 'भुगतान करें',
        amount: 'राशि',
        payNow: 'अभी भुगतान करें',
        submit: 'जमा करें',
        cancel: 'रद्द करें',
        success: 'सफल!',
        processing: 'प्रसंस्करण...',
        back: 'डैशबोर्ड पर वापस',
        selectLanguage: 'भाषा चुनें',
        noNotifications: 'कोई नई सूचना नहीं',
        billAmount: 'बिल राशि',
        dueDate: 'नियत तारीख',
        status: 'स्थिति',
        paid: 'भुगतान किया',
        pending: 'लंबित',
        overdue: 'अतिदेय',
        // Receipt translations
        receipt: 'रसीद',
        transactionId: 'लेनदेन आईडी',
        paymentDate: 'भुगतान तिथि',
        paymentMethod: 'भुगतान विधि',
        customerDetails: 'ग्राहक विवरण',
        serviceDetails: 'सेवा विवरण',
        billingPeriod: 'बिलिंग अवधि',
        consumption: 'खपत',
        billId: 'बिल आईडी',
        sendToMobile: 'मोबाइल पर भेजें',
        sendToEmail: 'ईमेल पर भेजें',
        printReceipt: 'रसीद प्रिंट करें',
        downloadPDF: 'पीडीएफ डाउनलोड करें',
        receiptGenerated: 'आपकी रसीद तैयार हो गई है',
        sent: 'भेज दिया!',
        serviceType: 'सेवा प्रकार',
    },
    ta: {
        welcome: 'சுவிதாவிற்கு வரவேற்கிறோம்',
        subtitle: 'ஸ்மார்ட் நகர்ப்புற டிஜிட்டல் உதவியாளர்',
        selectService: 'சேவையைத் தேர்ந்தெடுக்கவும்',
        electricity: 'மின்சாரம்',
        gas: 'எரிவாயு',
        water: 'நீர்',
        waste: 'கழிவு மேலாண்மை',
        login: 'குடிமக்கள் உள்நுழைவு',
        loginSubtitle: 'பாதுகாப்பான அங்கீகாரம் தேவை',
        consumerId: 'நுகர்வோர் ஐடி / மொபைல்',
        password: 'கடவுச்சொல் / OTP',
        loginBtn: 'பாதுகாப்பாக உள்நுழைக',
        services: 'சேவைகள்',
        payBill: 'பில் செலுத்து',
        newConnection: 'புதிய இணைப்பு',
        complaints: 'புகார் பதிவு',
        trackStatus: 'நிலையைக் கண்காணி',
        viewBill: 'பில் பார்க்க',
        meterReading: 'மீட்டர் வாசிப்பு சமர்ப்பி',
        logout: 'வெளியேறு',
        dashboard: 'டாஷ்போர்டு',
        accountDetails: 'கணக்கு விவரங்கள்',
        consumptionHistory: 'நுகர்வு வரலாறு',
        recentActivity: 'சமீபத்திய செயல்பாடு',
        notifications: 'அறிவிப்புகள்',
        downloadReceipt: 'ரசீது பதிவிறக்கம்',
        makePayment: 'பணம் செலுத்து',
        amount: 'தொகை',
        payNow: 'இப்போது செலுத்து',
        submit: 'சமர்ப்பி',
        cancel: 'ரத்து செய்',
        success: 'வெற்றி!',
        processing: 'செயலாக்குகிறது...',
        back: 'டாஷ்போர்டுக்கு திரும்பு',
        selectLanguage: 'மொழியைத் தேர்ந்தெடுக்கவும்',
        noNotifications: 'புதிய அறிவிப்புகள் இல்லை',
    },
    // ==========================================
    // ASSAMESE (অসমীয়া) - Official language of Assam
    // Used with authentic Assamese lingo and expressions
    // ==========================================
    as: {
        welcome: 'সুবিধালৈ স্বাগতম',
        subtitle: 'স্মাৰ্ট নগৰীয়া ডিজিটেল সহায়ক',
        selectService: 'সেৱা বাছনি কৰক',
        electricity: 'বিজুলী',
        gas: 'গেছ',
        water: 'পানী',
        waste: 'আৱৰ্জনা ব্যৱস্থাপনা',
        login: 'নাগৰিক লগইন',
        loginSubtitle: 'সুৰক্ষিত প্ৰমাণীকৰণ প্ৰয়োজন',
        consumerId: 'গ্ৰাহক আইডি / মোবাইল',
        password: 'পাছৱৰ্ড / অটিপি',
        loginBtn: 'সুৰক্ষিতভাৱে লগইন কৰক',
        services: 'সেৱাসমূহ',
        payBill: 'বিল পৰিশোধ',
        newConnection: 'নতুন সংযোগ',
        complaints: 'অভিযোগ দাখিল কৰক',
        trackStatus: 'স্থিতি অনুসৰণ কৰক',
        viewBill: 'বিল চাওক',
        meterReading: 'মিটাৰ ৰিডিং দাখিল কৰক',
        logout: 'লগআউট',
        dashboard: 'ডেচব\'ৰ্ড',
        accountDetails: 'একাউণ্টৰ বিৱৰণ',
        consumptionHistory: 'ব্যৱহাৰৰ ইতিহাস',
        recentActivity: 'শেহতীয়া কাৰ্যকলাপ',
        notifications: 'জাননী',
        downloadReceipt: 'ৰচিদ ডাউনলোড কৰক',
        makePayment: 'পৰিশোধ কৰক',
        amount: 'পৰিমাণ',
        payNow: 'এতিয়াই পৰিশোধ কৰক',
        submit: 'দাখিল কৰক',
        cancel: 'বাতিল কৰক',
        success: 'সফল!',
        processing: 'প্ৰক্ৰিয়াকৰণ হৈ আছে...',
        back: 'ডেচব\'ৰ্ডলৈ উভতি যাওক',
        selectLanguage: 'ভাষা বাছনি কৰক',
        noNotifications: 'কোনো নতুন জাননী নাই',
        billAmount: 'বিলৰ পৰিমাণ',
        dueDate: 'দিবলগীয়া তাৰিখ',
        status: 'স্থিতি',
        paid: 'পৰিশোধ কৰা হৈছে',
        pending: 'বাকী আছে',
        overdue: 'সময়সীমা পাৰ হৈছে',
        complaintType: 'অভিযোগৰ প্ৰকাৰ',
        description: 'বিৱৰণ',
        uploadDoc: 'নথি আপলোড কৰক',
        trackingId: 'ট্ৰেকিং আইডি',
        newConnectionType: 'সংযোগৰ প্ৰকাৰ',
        address: 'ঠিকনা',
        idProof: 'পৰিচয় পত্ৰ',
        addressProof: 'ঠিকনাৰ প্ৰমাণ',
        powerOutage: 'বিজুলী কটা গৈছে',
        billing: 'বিলৰ সমস্যা',
        meterFault: 'মিটাৰৰ সমস্যা',
        gasLeak: 'গেছ লিক হৈছে',
        lowPressure: 'কম চাপ',
        waterSupply: 'পানী যোগানৰ সমস্যা',
        qualityIssue: 'পানীৰ মান',
        missedCollection: 'সংগ্ৰহ বাদ পৰিছে',
        illegalDumping: 'অবৈধ পেলনীয়া',
        residential: 'আৱাসিক',
        commercial: 'বাণিজ্যিক',
        industrial: 'ঔদ্যোগিক',
        adminDashboard: 'প্ৰশাসন ডেচব\'ৰ্ড',
        totalTransactions: 'মুঠ লেনদেন',
        activeComplaints: 'সক্ৰিয় অভিযোগ',
        todayCollection: 'আজিৰ সংগ্ৰহ',
        kioskUsage: 'কিয়স্কৰ ব্যৱহাৰ',
    },
    // ==========================================
    // BENGALI (বাংলা) - Widely spoken in Barak Valley, Assam
    // Using dialect influenced by Sylheti/Barak Valley region
    // ==========================================
    bn: {
        welcome: 'সুবিধাতে স্বাগতম',
        subtitle: 'স্মার্ট শহুরে ডিজিটাল সহায়ক',
        selectService: 'সেবা নির্বাচন করুন',
        electricity: 'বিদ্যুৎ',
        gas: 'গ্যাস',
        water: 'জল',
        waste: 'বর্জ্য ব্যবস্থাপনা',
        login: 'নাগরিক লগইন',
        loginSubtitle: 'সুরক্ষিত প্রমাণীকরণ প্রয়োজন',
        consumerId: 'গ্রাহক আইডি / মোবাইল',
        password: 'পাসওয়ার্ড / ওটিপি',
        loginBtn: 'সুরক্ষিতভাবে লগইন করুন',
        services: 'সেবাসমূহ',
        payBill: 'বিল পরিশোধ',
        newConnection: 'নতুন সংযোগ',
        complaints: 'অভিযোগ দাখিল করুন',
        trackStatus: 'অবস্থা অনুসরণ করুন',
        viewBill: 'বিল দেখুন',
        meterReading: 'মিটার রিডিং জমা দিন',
        logout: 'লগআউট',
        dashboard: 'ড্যাশবোর্ড',
        accountDetails: 'অ্যাকাউন্টের বিবরণ',
        consumptionHistory: 'ব্যবহারের ইতিহাস',
        recentActivity: 'সাম্প্রতিক কার্যকলাপ',
        notifications: 'বিজ্ঞপ্তি',
        downloadReceipt: 'রসিদ ডাউনলোড করুন',
        makePayment: 'পেমেন্ট করুন',
        amount: 'পরিমাণ',
        payNow: 'এখনই পরিশোধ করুন',
        submit: 'জমা দিন',
        cancel: 'বাতিল করুন',
        success: 'সফল!',
        processing: 'প্রক্রিয়াকরণ হচ্ছে...',
        back: 'ড্যাশবোর্ডে ফিরে যান',
        selectLanguage: 'ভাষা নির্বাচন করুন',
        noNotifications: 'কোনো নতুন বিজ্ঞপ্তি নেই',
        billAmount: 'বিলের পরিমাণ',
        dueDate: 'নির্ধারিত তারিখ',
        status: 'অবস্থা',
        paid: 'পরিশোধ করা হয়েছে',
        pending: 'বাকি আছে',
        overdue: 'সময়সীমা পেরিয়েছে',
        complaintType: 'অভিযোগের ধরন',
        description: 'বিবরণ',
        uploadDoc: 'নথি আপলোড করুন',
        trackingId: 'ট্র্যাকিং আইডি',
        newConnectionType: 'সংযোগের ধরন',
        address: 'ঠিকানা',
        idProof: 'পরিচয়পত্র',
        addressProof: 'ঠিকানার প্রমাণ',
        powerOutage: 'বিদ্যুৎ বিভ্রাট',
        billing: 'বিলিং সমস্যা',
        meterFault: 'মিটার ত্রুটি',
        gasLeak: 'গ্যাস লিক',
        lowPressure: 'কম চাপ',
        waterSupply: 'জল সরবরাহ সমস্যা',
        qualityIssue: 'জলের গুণমান',
        missedCollection: 'সংগ্রহ বাদ পড়েছে',
        illegalDumping: 'অবৈধ ফেলা',
        residential: 'আবাসিক',
        commercial: 'বাণিজ্যিক',
        industrial: 'শিল্প',
        adminDashboard: 'অ্যাডমিন ড্যাশবোর্ড',
        totalTransactions: 'মোট লেনদেন',
        activeComplaints: 'সক্রিয় অভিযোগ',
        todayCollection: 'আজকের সংগ্রহ',
        kioskUsage: 'কিয়স্ক ব্যবহার',
    },
    // ==========================================
    // BODO (बड़ो) - Recognized tribal language of Assam
    // Official language in Bodoland Territorial Region
    // ==========================================
    brx: {
        welcome: 'सुबिधायाव सानहाथि बोहैबाय',
        subtitle: 'स्मार्ट नोगोरारि डिजिटेल हेल्पदेस्क',
        selectService: 'सेवा सायख',
        electricity: 'बिजुली',
        gas: 'गेस',
        water: 'दै',
        waste: 'गारबेज मेनेजमेन्ट',
        login: 'नागरिक लगइन',
        loginSubtitle: 'सुरखा प्रमाणीकरण दरकार',
        consumerId: 'ग्राहक आइडि / मबाइल',
        password: 'पासवर्ड / ओटिपि',
        loginBtn: 'सुरखायाव लगइन खालाम',
        services: 'सेवाफोर',
        payBill: 'बिल पेमेन्ट',
        newConnection: 'गोदान कनेक्सन',
        complaints: 'बेसाद दाखिल खालाम',
        trackStatus: 'स्थिति ट्रेक खालाम',
        viewBill: 'बिल नाय',
        meterReading: 'मिटार रिडिं जमा खालाम',
        logout: 'लगआउट',
        dashboard: 'डेसबर्ड',
        accountDetails: 'एकाउन्ट बिबुंथि',
        consumptionHistory: 'बाहायनाय जारिमिन',
        recentActivity: 'गोबां खामानि',
        notifications: 'फोरमायथि',
        downloadReceipt: 'रसिद डाउनलड खालाम',
        makePayment: 'पेमेन्ट खालाम',
        amount: 'बेसेन',
        payNow: 'दाबो पेमेन्ट खालाम',
        submit: 'जमा खालाम',
        cancel: 'बातिल खालाम',
        success: 'जाफुंसार!',
        processing: 'प्रसेस जाबाय...',
        back: 'डेसबर्डयाव थांना',
        selectLanguage: 'रावखौ सायख',
        noNotifications: 'गोदान फोरमायथि गैया',
        billAmount: 'बिल बेसेन',
        dueDate: 'होनाय सान',
        status: 'स्थिति',
        paid: 'होदां',
        pending: 'लागियो',
        overdue: 'सम गैदों',
        complaintType: 'बेसाद मोजां',
        description: 'बिबुंथि',
        uploadDoc: 'कागज अपलड खालाम',
        trackingId: 'ट्रेकिं आइडि',
        newConnectionType: 'कनेक्सन मोजां',
        address: 'थाखाय',
        idProof: 'परिचय कागज',
        addressProof: 'थाखाय प्रमाण',
        powerOutage: 'बिजुली गैया',
        billing: 'बिलिं समस्या',
        meterFault: 'मिटार गोरोन्थि',
        gasLeak: 'गेस लिक',
        lowPressure: 'हाब्रा प्रेसार',
        waterSupply: 'दै जोगान समस्या',
        qualityIssue: 'दैनि गुन',
        missedCollection: 'सोंग्रह बाद जादों',
        illegalDumping: 'बेआइनी फेलानाय',
        residential: 'थानाय',
        commercial: 'बानिज्यिक',
        industrial: 'उद्योग',
        adminDashboard: 'एडमिन डेसबर्ड',
        totalTransactions: 'जम्मा लेनदेन',
        activeComplaints: 'थाग्रा बेसाद',
        todayCollection: 'दिनैनि सोंग्रह',
        kioskUsage: 'कियस्क बाहायनाय',
    },
    // ==========================================
    // KARBI (কাৰ্বি) - Language of Karbi people
    // Spoken in Karbi Anglong district of Assam
    // ==========================================
    kha: {
        welcome: 'সুবিধা-পেন স্বাগতম',
        subtitle: 'স্মাৰ্ট আৰবান ডিজিটেল হেল্পডেস্ক',
        selectService: 'ছাৰ্ভিচ চকলং',
        electricity: 'মেই-আৰং',
        gas: 'গেছ',
        water: 'লাংটুক',
        waste: 'জিলাং মেনেজমেন্ট',
        login: 'চিটিজেন লগইন',
        loginSubtitle: 'চেকিউৰ অথেন্টিকেচন দৰকাৰ',
        consumerId: 'কনজিউমাৰ আইডি / মোবাইল',
        password: 'পাছৱৰ্ড / অটিপি',
        loginBtn: 'চেকিউৰ লগইন থে',
        services: 'ছাৰ্ভিচ-পে',
        payBill: 'বিল পেমেন্ট',
        newConnection: 'অথুৰ কানেকচন',
        complaints: 'কম্প্লেইন্ট দাখিল থে',
        trackStatus: 'ষ্টেটাছ ট্ৰেক থে',
        viewBill: 'বিল নেলং',
        meterReading: 'মিটাৰ ৰিডিং জমা থে',
        logout: 'লগআউট',
        dashboard: 'ডেচবৰ্ড',
        accountDetails: 'একাউণ্ট ডিটেইলচ',
        consumptionHistory: 'কনজাম্পচন হিষ্ট্ৰি',
        recentActivity: 'ৰিচেন্ট একটিভিটি',
        notifications: 'নটিফিকেচন-পে',
        downloadReceipt: 'ৰচিদ ডাউনলোড থে',
        makePayment: 'পেমেন্ট থে',
        amount: 'এমাউন্ট',
        payNow: 'আনে পেমেন্ট থে',
        submit: 'জমা থে',
        cancel: 'কেনচেল থে',
        success: 'ছক্সেছ!',
        processing: 'প্ৰচেছিং...',
        back: 'ডেচবৰ্ড-পেন ৱাপচ',
        selectLanguage: 'লাংগুৱেজ চকলং',
        noNotifications: 'অথুৰ নটিফিকেচন মং',
        billAmount: 'বিল এমাউন্ট',
        dueDate: 'ডিউ ডেট',
        status: 'ষ্টেটাছ',
        paid: 'পেইড',
        pending: 'পেণ্ডিং',
        overdue: 'অভাৰডিউ',
        complaintType: 'কম্প্লেইন্ট টাইপ',
        description: 'ডিস্ক্ৰিপচন',
        uploadDoc: 'ডকুমেন্ট আপলোড থে',
        trackingId: 'ট্ৰেকিং আইডি',
        newConnectionType: 'কানেকচন টাইপ',
        address: 'এড্ৰেছ',
        idProof: 'আইডি প্ৰুফ',
        addressProof: 'এড্ৰেছ প্ৰুফ',
        powerOutage: 'মেই-আৰং মং',
        billing: 'বিলিং ঈচু',
        meterFault: 'মিটাৰ ফল্ট',
        gasLeak: 'গেছ লিক',
        lowPressure: 'লো প্ৰেচাৰ',
        waterSupply: 'লাংটুক চাপ্লাই ঈচু',
        qualityIssue: 'লাংটুক কোৱালিটি',
        missedCollection: 'কালেকচন মিছ',
        illegalDumping: 'ইল্লিগেল ডাম্পিং',
        residential: 'ৰেচিডেন্সিয়েল',
        commercial: 'কমাৰ্চিয়েল',
        industrial: 'ইন্ডাষ্ট্ৰিয়েল',
        adminDashboard: 'এডমিন ডেচবৰ্ড',
        totalTransactions: 'টটেল ট্ৰেনজেকচন',
        activeComplaints: 'একটিভ কম্প্লেইন্ট',
        todayCollection: 'আননি কালেকচন',
        kioskUsage: 'কিয়স্ক ইউজেজ',
    }
};
